module.exports = __webpack_public_path__ + "static/img/3.610bf29.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/eng/3.png
// module id = Rbhw
// module chunks = 0